import { useLocalSuperstore } from './useLocalSuperstore';
import { useIsDisabledByAccessControls } from '../components/CopilotPreview/internal/hooks/useIsDisabledByAccessControls';
import { useCallback, useMemo } from 'react';
export const COPILOT_PREVIEW_DONT_SHOW_AGAIN_WHEN_DISABLED_STORAGE_KEY = 'COPILOT_PREVIEW_DONT_SHOW_AGAIN_WHEN_DISABLED';
export const useShouldShowCopilotPreviews = ({
  overrideDisabled = false
} = {}) => {
  const {
    isDisabledByAccessControls
  } = useIsDisabledByAccessControls(true);
  const {
    localSuperstoreValue,
    handleSetLocalSuperstoreValue
  } = useLocalSuperstore({
    key: COPILOT_PREVIEW_DONT_SHOW_AGAIN_WHEN_DISABLED_STORAGE_KEY
  });
  const isDisabled = isDisabledByAccessControls || overrideDisabled;
  const shouldShowCopilotPreviews = !isDisabled || localSuperstoreValue !== 'true';
  const setDontShowAgain = useCallback(() => {
    handleSetLocalSuperstoreValue('true');
  }, [handleSetLocalSuperstoreValue]);
  const value = useMemo(() => {
    return {
      shouldShowCopilotPreviews,
      setDontShowAgain
    };
  }, [shouldShowCopilotPreviews, setDontShowAgain]);
  return value;
};